import {Component, OnDestroy, OnInit} from '@angular/core';
import {NetworkService} from "../../../services/network.service";
import {MotivoDesoneracao} from '../../../model/motivo-desoneracao.model';
import {ActivatedRoute ,Router} from "@angular/router";
import {getUrlImplante,URL_BASE} from "../../../controller/staticValues";
import {MessageService} from "primeng/api";
import { Subscription } from 'rxjs'
import {Formulario} from "../../../controller/Formulario";
import {DadosDefaultService} from "../../../services/dados-default.service";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Util } from 'src/app/controller/Util';

@Component({
    selector: 'app-editar-motivo-desoneracao',
    templateUrl: './editar-motivo-desoneracao.component.html',
    styleUrls: ['./editar-motivo-desoneracao.component.css'],
    standalone: false
})
export class EditarMotivoDesoneracaoComponent implements OnInit{

  entObj = new MotivoDesoneracao()
  public lista: any[] = []
  form: UntypedFormGroup;
  usuario: any;
  id: any;

  selectCodigo = [];


    constructor(private fb: UntypedFormBuilder,public route: ActivatedRoute, private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {
      this.form = Formulario.createForm(this.entObj, this.fb)
    }

    ngOnInit() {
        this.dadosDefaultService.motivoDesoneracao().subscribe(v => {
            this.selectCodigo = v[0];
        })
        
        this.route.paramMap.subscribe(params => {
          this.id = params.get('id');
            if (this.id) {
              this.networkService.buscar('MotivoDesoneracao', this.id, '', URL_BASE).subscribe(value => {
                const data = Formulario.prepareValueToForm(this.entObj, value);
                Object.keys(data).forEach(key => this.form.controls[key].setValue(data[key]))
              })
            }
        })
    }

    processarFormulario(){
      const data = Formulario.parseForm(this.entObj, Object.assign(this.form.value));
      this.route.url.subscribe(v => {
        if(v[0].path == 'editar-motivo-desoneracao'){
          this.networkService.atualizar(URL_BASE, 'MotivoDesoneracao', data).subscribe(value => {
            this.router.navigate(['motivo-desoneracao'])
          })
        }
        if(v[0].path == 'incluir-motivo-desoneracao'){
          this.networkService.salvarPost(URL_BASE, 'MotivoDesoneracao', data).subscribe(value => {
            this.router.navigate(['motivo-desoneracao'])
          })
        }
      })
    }

    cancelar(){
      this.router.navigate(['motivo-desoneracao']);
    }
}
